var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMixpanel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 50 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.947 19.0741H21.0659C19.538 18.1182 18.9659 16.7786 18.1983 14.2949L15.9029 5.78643C14.8529 1.96306 13.9912 0.145508 9.78402 0.145508H0.993164V2.44098H2.23866C4.81653 2.44098 5.10618 3.39682 5.87375 6.26435L7.87957 13.7228C8.92955 17.3579 10.5588 19.0741 14.9543 19.0741H14.947ZM29.1036 19.0741H35.2152C39.6106 19.0741 41.1385 17.3507 42.1958 13.7228L44.2016 6.26435C44.9691 3.39682 45.3457 2.44098 47.8367 2.44098H49.0822V0.145508H40.3855C36.0842 0.145508 35.2225 1.86892 34.2666 5.78643L31.9711 14.2949C31.2036 16.8727 30.6315 18.1182 29.1036 19.0741ZM21.0659 27.0974H29.1038L29.1036 19.0741H21.0659V27.0974ZM0.993164 46.0259H9.78402C13.9912 46.0259 14.8529 44.2084 15.9029 40.385L18.1983 31.8766C18.9659 29.3928 19.538 28.0532 21.0659 27.0974H14.947C10.5516 27.0974 8.92231 28.8208 7.87233 32.4486L5.86651 39.9071C5.09894 42.7746 4.81653 43.7305 2.23141 43.7305H0.993164V46.0259ZM40.371 46.0259H49.0677V43.7305H47.8222C45.3384 43.7305 44.9547 42.7746 44.1871 39.9071L42.1813 32.4486C41.1313 28.8135 39.6034 27.0974 35.2007 27.0974H29.1038C30.6317 28.0532 31.1818 29.2987 31.9494 31.8766L34.2449 40.385C35.2007 44.3025 36.0624 46.0259 40.3637 46.0259H40.371Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMixpanel);
export default __webpack_public_path__ + "static/media/mixpanel.049f1e8bc1bba9f1fdc7835432ea6022.svg";
export { ForwardRef as ReactComponent };